var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree-weather-clock"},[_c('strong',{domProps:{"innerHTML":_vm._s(_vm.temperature.celsius)}}),_vm._v(" "),_c(_vm.icon,{tag:"component",staticClass:"tree-weather-clock__icon"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }